export const FACILITY_PAGE_LIMIT = 10
export const FACILITY_LOCAL_STORAGE_KEY = 'BAF:UI:facilities'
